// react
import React, { useEffect, useContext} from 'react';
import useForm from 'react-hook-form';
import moment from "moment";
import ReactTable from "react-table";
import CsvDownloader from 'react-csv-downloader';
import { useTranslation } from 'react-i18next';
import Datetime from "react-datetime";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Equalizer from "@material-ui/icons/Equalizer";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import Select from 'react-select';
import {ValidSelect} from "beaktShared/helpers/validselect";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";

// services
import { MaskDate, validateDate, convertDate, formateDate, transformValueFloattoFormated, getLocale, getStringFormatDate } from "beaktShared/helpers/masks";
import { UseGetApiSimple, UsePostApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";

// styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function RelatorioVendabyServicos() {
    const { t } = useTranslation();

    const session = useContext(SessionContext);
    const { register, setValue, errors, setError, clearError, getValues } = useForm({mode: "onBlur"});
   
    const [notification, setNotification] = React.useState({
        show:false,
        color:'info',
        message:''
    });
    const showNotification = (message,color) => { 
        setNotification({
        show:true,
        color:color,
        message:message      
        });
        setTimeout(function() {
        setNotification({show:false});
        }, 6000);       
    };
    
    const [dtini, setdtini] = React.useState(formateDate(moment(new Date()).add(-7, 'days')));
    const [dtfim, setdtfim] = React.useState(formateDate(moment(new Date())));
    useEffect(() => {
        verifyAcess();
    }, []);

    const verifyAcess = () =>{
        if(session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            setshowSelectEstabelecimentos(true);
            LoadEstabelecimentos();
        }
        else //Acessando tela pelo modulo Clinica   
        {
            setlistSelectEstabelecimentosSelected([{estabelecimentoId:session.estabelecimentoId}]);
            setshowSelectEstabelecimentos(false)
        }
    }          

    const [showSelectEstabelecimentos, setshowSelectEstabelecimentos] = React.useState(true);
    const [listSelectEstabelecimentos, setlistSelectEstabelecimentos] = React.useState([]);
    const [listSelectEstabelecimentosSelected, setlistSelectEstabelecimentosSelected] = React.useState([]);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [loadingSelectEstabelecimentos, setloadingSelectEstabelecimentos] = React.useState(false);
    const LoadEstabelecimentos = () =>{
        setloadingSelectEstabelecimentos(true);   
        let endPointE = "estabelecimentos/ativos/byfranquia/"+session.franquiaId;
        UseGetApiSimple(endPointE).then(result=>{      
            if(result.status !== 200)
            {                                     
                showNotification(t('error_message.could_not_load_establishments')+"!",'danger'); 
                setloadingSelectEstabelecimentos(false); 
                return false; 
            }     
            setlistSelectEstabelecimentos(result.data);  
            setloadingSelectEstabelecimentos(false); 
            return true;                
        });  
    }
    const handleEstabelecimentoChange = event => {
        let value = event
        let data = getValues()

        let lstsAdd = [];
        let lstSelect = [];
        value.map(item =>{
            lstsAdd.push(item.estabelecimentoId); 
            
            lstSelect.push({
                estabelecimentoId:item.estabelecimentoId
            });                   
        });
        setestabelecimentos(lstsAdd); 
        setlistSelectEstabelecimentosSelected(lstSelect);

    }
    const handleClickSelecionarTodosEstabelecimentos = () =>{
        
        let data = getValues()
        let lstsAdd = [];
        let lstSelect = [];
        listSelectEstabelecimentos.map(item =>{
            lstsAdd.push(item.estabelecimentoId); 
            
            lstSelect.push({
                estabelecimentoId: item.estabelecimentoId
            });                   
        });
        setestabelecimentos(lstsAdd); 
        setlistSelectEstabelecimentosSelected(lstSelect);
    }

    const monthDiff = (dateFrom, dateTo) => {
        return dateTo.getMonth() - dateFrom.getMonth() + 
        (12 * (dateTo.getFullYear() - dateFrom.getFullYear()))
    }
    
    const handleClickPesquisa = () =>{
        let data = getValues();
        
        if (listSelectEstabelecimentosSelected.length === 0)
            return setError(t('label.establishment'), "required")
        else
            clearError("estabelecimentos")

        if(data.dtini === "")
        {
            setError("dtini","required", t('label.required'))
            return false;
        }
        else
            clearError("dtini")
        
        if(data.dtfim === "")
        {
            setError("dtfim","required", t('label.required'))
            return false;
        }
        else
            clearError("dtfim")
        
        if (!validateDate(data.dtini)) {
            setError("dtini", "invaliddate", t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtini")
        
        if (!validateDate(data.dtfim)) {
            setError("dtfim", "invaliddate",  t('error_message.invalid_date'))
            return false;
        }
        else
            clearError("dtfim")
        
        var dataIniConvertida = convertDate(data.dtini);
        var dataFimConvertida = convertDate(data.dtfim);
        
        if(monthDiff(dataIniConvertida,dataFimConvertida) > 3){            
            showNotification(t('error_message.select_3month'), 'danger')
            return false; 
        }        

        let obj = {
            estabelecimentos: listSelectEstabelecimentosSelected,
            dataIni:dataIniConvertida,
            dataFim:dataFimConvertida
        }
        loadDados(obj);
    };

    const [isLoadingList, setisLoadingList] = React.useState(false);
    const [list, setlist] = React.useState([]);
    const loadDados = (obj) =>{ 
        setisLoadingList(true);       
        const endPoint = "relatorios/relresumoservicos/";
        UsePostApi(endPoint,obj).then(result=>{    
            if(result.status !== 200)
            {   
                showNotification(result.message, 'danger')
                setisLoadingList(false);
                return false; 
            }                
            setlist(result.data);
            loadDataCsv(result.data);
            setisLoadingList(false);   
            return true;                
        });  
    }

    const columnsProp = [{
        Header: t('label.description'),
        filterable: false,
        accessor: "descricao",
        width: 400,
    },
    {
        Header: t('label.qty'),
        filterable: false,
        accessor: "qtd"
    },
    {
        Header: t('label.value'),
        filterable: false,
        accessor: "totalValor",
        Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div>
    },
    {
        Header: t('label.discount'),
        filterable: false,
        accessor: "totalDescontos",
        Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div>
    },
    {
        Header: t('label.liquid'),
        filterable: false,
        accessor: "totalLiquido",
        Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div>
    }
    ]
    const columns = [...columnsProp]
     
    const [dataCSV,setdataCSV] = React.useState([]);  
    const columnsCSV = [
        { displayName: "Descrição", id: "descricao" },
        { displayName: "Qtd", id: "qtd" },
        { displayName: "Valor", id: "totalValor" },
        { displayName: "Descontos", id: "totalDescontos" },,
        { displayName: "Liquido", id: "totalLiquido" },
    ];
    const loadDataCsv = (data) =>{
        let dtCsv = [];

        data.map(item =>{
            var obj = {
                descricao: item.descricao,
                qtd: item.qtd,
                totalValor: item.totalValor,
                totalDescontos: item.totalDescontos,
                totalLiquido: item.totalLiquido, 
            };
            dtCsv.push(obj);
        })

        setdataCSV(dtCsv);
    } 

    const classes = useStyles();
    return (
    <div>
        <GridContainer>            
            <GridItem xs={12}>
                <Card>
                    <CardHeader color="primary" icon>
                        <CardIcon color="primary">
                            <Assignment />
                        </CardIcon>
                        <h4 className={classes.cardIconTitle}>
                            {t('sidebar.service_sales')}
                        </h4>
                    </CardHeader>
                    <CardBody>
                    <GridContainer>
                        {showSelectEstabelecimentos &&
                        <GridItem xs={12} sm={12} md={12}>
                            <FormControl fullWidth className={classes.formControl}>
                                <label className={errors.estabelecimentos?"select__label select__label_error":"select__label"}>
                                {t('label.establishment')} </label>
                                <Select
                                    classNamePrefix="select"  
                                    isSearchable={true}
                                    styles={ValidSelect(errors.estabelecimentos?true:false)} 
                                    placeholder={t('label.select')+"..."}
                                    isMulti={true}    
                                    name="estabelecimentos"                                  
                                    isLoading={loadingSelectEstabelecimentos}
                                    options={listSelectEstabelecimentos}     
                                    getOptionLabel={({descricao}) => descricao}
                                    getOptionValue={({estabelecimentoId}) => estabelecimentoId} 
                                    value={listSelectEstabelecimentos.filter(({estabelecimentoId}) => estabelecimentos.indexOf(estabelecimentoId) != -1)}
                                    onChange={(value) => handleEstabelecimentoChange(value || [])}                                      
                                    ref={() => register( { name: "estabelecimentos" }) }
                                />
                                {errors.estabelecimentos &&
                                <FormHelperText>
                                    <span className="obg"> {t('label.select_an_establishment')} </span>
                                </FormHelperText>}
                            
                                <div style={{textAlign:'right',marginTop:'3px'}}>
                                <a href="#"  onClick={() => handleClickSelecionarTodosEstabelecimentos()} style={{marginTop:'10px'}}>
                                {t('label.select_all_establishments')}
                                </a></div>
                            </FormControl> 
                        </GridItem>}
                        <GridItem xs={12} sm={6} md={3}>
                            <FormControl fullWidth className={classes.formControl}>                                                               
                                <label className={errors.dtini?"select__label select__label_error":"select__label"}>
                                    {t('label.ini_date')+" *"}  </label>
                                <Datetime                                    
                                    locale={getLocale()}
                                    dateFormat={getStringFormatDate()}
                                    timeFormat={false}                                    
                                    name="dtini"                                      
                                    defaultValue={dtini}
                                    value={dtini}
                                    onChange={date => { setdtini(date) }}
                                    inputProps={{name:"dtini", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                    className={errors.dtini?"error":""}            
                                />       
                                {errors.dtini && <FormHelperText className={classes.labelRootError}>
                                    <span> {errors.dtini.message} </span>                                                                          
                                </FormHelperText>} 
                            </FormControl>                                 
                        </GridItem>
                        <GridItem xs={12} sm={6} md={3}>
                            <FormControl fullWidth className={classes.formControl}>                                                               
                                <label className={errors.dtfim?"select__label select__label_error":"select__label"}>
                                    {t('label.end_date')+" *"}  </label>
                                <Datetime                                    
                                    locale={getLocale()}
                                    dateFormat={getStringFormatDate()}
                                    timeFormat={false}                                    
                                    name="dtfim"                                      
                                    defaultValue={dtfim}
                                    value={dtfim}
                                    onChange={date => { setdtfim(date) }}
                                    inputProps={{name:"dtfim", ref:register({required: true}) , readOnly:'readonly' }}                                    
                                    className={errors.dtfim?"error":""}            
                                />       
                                {errors.dtfim && <FormHelperText className={classes.labelRootError}>
                                    <span> {errors.dtfim.message} </span>                                                                          
                                </FormHelperText>} 
                            </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={6} md={2}>
                            <Button  round color="primary" 
                                onClick={e => { handleClickPesquisa()}}>
                                {t('label.search')}
                            </Button>
                        </GridItem>
                        {notification.show &&
                        <div>
                            <br/>
                            <SnackbarContent
                                message={notification.message}
                                color={notification.color}
                                closeNotification={() => setNotification({show:false})}
                                close
                            />
                        </div>}
                    </GridContainer>   
                    
                    {dataCSV.length > 0 &&
                        <div>
                            <div style={{float:'right'}}>
                            <CsvDownloader
                            filename="report"
                            columns={columnsCSV}
                            datas={dataCSV}
                            separator={";"}>
                                <Button  round color="default" size="sm" >CSV</Button> 
                            </CsvDownloader>
                            </div><div style={{clear:'both'}}></div>
                        </div>
                    }
                    <div style={{overflow:'auto',width:'100%'}}>
                        <div style={{minWidth:'1000px'}}> 
                        {/*  */}
                            <ReactTable                  
                                loading = {isLoadingList}
                                data={list}
                                filterable
                                defaultFilterMethod = {noCaseSensitive}
                                columns={columns}
                                //defaultPageSize={10}              
                                style={{height: "400px"}}
                                showPagination={false}
                                pageSize={list.length}
                                minRows={5}
                                className="-striped -highlight"
                                previousText={t('button.previous')}
                                nextText={t('button.next')}
                                loadingText={t('label.loading')+"..."}
                                noDataText={t('information_message.no_records_found')+"!"}
                                pageText={t('label.page')}
                                ofText={t('label.of')}
                                rowsText={t('label.rows')}
                            />
                    </div>
                    </div>
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
    </div>
    );
}